import React from "react";
import { Link } from "react-router-dom";

export const Footer = ({ data }) => {
  const year = 2025;

  return (
    <footer id="footer">
      <div className="footer-top">
        <div className="container">
          <div className="row">
            {/* Brand & About */}
            <div className="col-md-4 col-sm-6 footer-col">
              <div className="footer-brand">
                <img src="/img/logo/logo2.png" alt="Transwave Shipping Logo" className="footer-logo" />
              </div>
              <div className="footer-social">
                {data?.facebook && (
                  <a href={data.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                    <i className="fa fa-facebook"></i>
                  </a>
                )}
                {data?.instagram && (
                  <a href={data.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                    <i className="fa fa-instagram"></i>
                  </a>
                )}
                {data?.linkedin && (
                  <a href={data.linkedin} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                    <i className="fa fa-linkedin"></i>
                  </a>
                )}
                {data?.whatsapp && (
                  <a href={data.whatsapp} target="_blank" rel="noopener noreferrer" aria-label="WhatsApp">
                    <i className="fa fa-whatsapp"></i>
                  </a>
                )}
              </div>
            </div>

            {/* Quick Links */}
            <div className="col-md-2 col-sm-6 footer-col">
              <h4 className="footer-heading">Quick Links</h4>
              <ul className="footer-links">
                <li><Link to="/">Home</Link></li>
                <li><Link to="/about">About Us</Link></li>
                <li><Link to="/services">Services</Link></li>
                <li><Link to="/gallery">Gallery</Link></li>
                <li><Link to="/compliance">Compliance</Link></li>
                <li><Link to="/contact">Contact</Link></li>
              </ul>
            </div>

            {/* Services */}
            <div className="col-md-3 col-sm-6 footer-col">
              <h4 className="footer-heading">Our Services</h4>
              <ul className="footer-links">
                <li><i className="fa fa-ship"></i> Sea Freight (FCL &amp; LCL)</li>
                <li><i className="fa fa-plane"></i> Air Freight</li>
                <li><i className="fa fa-truck"></i> Road Transport</li>
                <li><i className="fa fa-file-text-o"></i> Customs Clearance</li>
                <li><i className="fa fa-cubes"></i>Cargo Handling</li>
                <li><i className="fa fa-globe"></i> Multi-Modal Logistics</li>
              </ul>
            </div>

            {/* Contact Info */}
            <div className="col-md-3 col-sm-6 footer-col">
              <h4 className="footer-heading">Contact Us</h4>
              <ul className="footer-contact-list">
                {data?.address && (
                  <li>
                    <i className="fa fa-map-marker"></i>
                    <span>{data.address}</span>
                  </li>
                )}
                {data?.phone && (
                  <li>
                    <i className="fa fa-phone"></i>
                    <a href={`tel:${data.phone.replace(/\s/g, "")}`}>{data.phone}</a>
                  </li>
                )}
                {data?.email && (
                  <li>
                    <i className="fa fa-envelope-o"></i>
                    <a href={`mailto:${data.email}`}>{data.email}</a>
                  </li>
                )}
                {data?.officeHours && (
                  <li>
                    <i className="fa fa-clock-o"></i>
                    <span>{data.officeHours}</span>
                  </li>
                )}
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container">
          <div className="row">
            <div className="col-xs-12 text-center">
              <p>
                &copy; {year} Transwave Shipping and Logistics LLC. All rights reserved.
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
